/**
 * Legacy keys written before worksheet state moved to session memory + optional APIs.
 * Call once at browser startup so orphaned PHI is not left in `localStorage`.
 */
export function purgeLegacyWorksheetLocalStorageKeys(): void {
  if (typeof localStorage === "undefined") {
    return;
  }
  const prefixes = [
    "wa-clinic-worksheet-saved-views",
    "wa-clinic-worksheet-worklists",
    "worksheet-worklists-panel-collapsed",
  ] as const;
  const toRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (!k) {
      continue;
    }
    for (const p of prefixes) {
      if (k === p || k.startsWith(`${p}::`)) {
        toRemove.push(k);
        break;
      }
    }
  }
  for (const k of toRemove) {
    localStorage.removeItem(k);
  }
}
